import React, { useContext } from 'react';
import { LangCtx } from '../../context';
// For CSS
import './Dropdown.css';

const DropDown = (props) => {
    const { l } = useContext(LangCtx);
    return (
        <div className={`selectInput ${props.size}`}>
            <select onChange={props.onChange} value={props.value} name={props.name}>
                {props.items &&
                    props.items.length > 0 &&
                    props.items.map((item) => (
                        <option value={item.value} key={item.value}>
                            {item.label ? item.label : item.defaultlabel ? l[item.defaultlabel] : l[item.value]}
                        </option>
                    ))}
            </select>
            <label>{props.labelText}</label>
        </div>
    );
};
export default DropDown;
